module.exports = __webpack_public_path__ + "img/1-quad.c47f7ef0.png";